import { render, staticRenderFns } from "./visualizadosRetiradosNaoRetirados.vue?vue&type=template&id=2d5f79d5"
import script from "./visualizadosRetiradosNaoRetirados.vue?vue&type=script&lang=js"
export * from "./visualizadosRetiradosNaoRetirados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports